import React from 'react';
import styles from './ComDomainHeader.scss';
import ComponentSearchDomainForm from '../../../components/ComponentSearchDomainForm/ComponentSearchDomainForm';
import {__t} from '../../../common/lang/text-resource';


export default function ComDomainHeader() {
	return (
	  <header className={styles.header}>
		  <div className={styles.ship}></div>
		  <div className={styles.waves}></div>
		  <div className={styles.innerHeader}>
			  <div className={styles.formContainer}>
				  <h1>{__t("Домейн")} <span>.com</span></h1>
				  <ComponentSearchDomainForm
					isTransparent={true}
					doNotCalcInputWidth={true}
					placeholder={'mysupersite.com'}
					animationPlaceholders={['mysupersite.com']}/>
			  </div>
		  </div>
	  </header>
	)
}